$( document ).ready(function() {  	
  	$(window).on( "shopify-variants:switch-variant", function( event ) {
      
      	/*Gallery Main Thumbnails*/
		var ScrollLeftgo = $('.product-gallery--media-thumbnail[data-gallery-selected=true]').offset().left - $('.gallery-navigation--scroller').offset().left + $('.gallery-navigation--scroller').scrollLeft();
		var ScrollerWidthgo = $('.product-gallery--navigation').width()/2;
		var WidthActiveElgo = $('.product-gallery--media-thumbnail[data-gallery-selected=true]').width()/2;
      	var WidthButtonScroll= $('.gallery-navigation--scroll-button').width();
		$(".gallery-navigation--scroller").scrollLeft(ScrollLeftgo - ScrollerWidthgo + WidthActiveElgo + WidthButtonScroll);
      	/*Gallery Main Thumbnails*/
      

      
	}); 
  
    $( ".product-gallery--expand" ).click(function() {
      	/*Gallery Zoom Thumbnails*/
		var ScrollLeftgoTh = $('.product-zoom--thumbnails .product-gallery--media-thumbnail[data-gallery-selected=true]').offset().left - $('.product-zoom--thumb-scroller').offset().left + $('.product-zoom--thumb-scroller').scrollLeft();
		var ScrollerWidthgoTh = $('.product-zoom--thumbnails').width()/2;
		var WidthActiveElgoTh = $('.product-zoom--thumbnails .product-gallery--media-thumbnail[data-gallery-selected=true]').width()/2;
      	var WidthButtonScrollTh = $('.product-zoom--thumbnails .gallery-navigation--scroll-button').width();
		$(".product-zoom--thumb-scroller").scrollLeft(ScrollLeftgoTh - ScrollerWidthgoTh + WidthActiveElgoTh + WidthButtonScrollTh);  
      	/*Gallery Zoom Thumbnails*/    
	}); 
  
 	 $( ".goto-link" ).click(function() {
    	$('html, body').animate({
        scrollTop: $(".product-tabs").offset().top - 110
    	}, 2000);
	});  
  
  
});

$(window).on('resize', function(){
	/*Gallery Main Thumbnails*/
    var GalleryNavScrollerViewPort = $('.gallery-navigation--scroller').width();
    var GalleryNavScrollerWidth = $(".gallery-navigation--scroller").get(0).scrollWidth;
	var ScrollBarDifference = GalleryNavScrollerWidth - GalleryNavScrollerViewPort;
	/*Gallery Main Thumbnails*/
	
	/*Gallery Zoom Thumbnails*/
    var GalleryNavScrollerViewPortThumbnail = $('.product-zoom--thumb-scroller').width();
    var GalleryNavScrollerWidthThumbnail = $(".product-zoom--thumb-scroller").get(0).scrollWidth;
	var ScrollBarDifferenceThumbnail = GalleryNavScrollerWidthThumbnail - GalleryNavScrollerViewPortThumbnail;
	/*Gallery Zoom Thumbnails*/
  
  
  	/*Gallery Main Thumbnails*/
    var checkExistGallery = setInterval(function() {
       if ($('.product-gallery--media-thumbnail.product-gallery--image-thumbnail').length) {
           if(Math.round(ScrollBarDifference) < 15){
	 			$(".product-gallery--navigation .gallery-navigation--scroll-button").removeClass("visible-cs");
			}else{
	 			$(".product-gallery--navigation .gallery-navigation--scroll-button").addClass("visible-cs");
				
			}
         clearInterval(checkExistGallery);	
       }
    }, 100);  
  /*Gallery Main Thumbnails*/
  
  /*Gallery Zoom Thumbnails*/
    var checkExistZoom = setInterval(function() {
       if ($('.product-gallery--media-thumbnail.product-gallery--image-thumbnail').length) {
           if(Math.round(ScrollBarDifferenceThumbnail) < 15){
	 			$(".product-zoom--thumbnails .gallery-navigation--scroll-button").removeClass("visible-cs");
			}else{
	 			$(".product-zoom--thumbnails .gallery-navigation--scroll-button").addClass("visible-cs");
				
			}
         clearInterval(checkExistZoom);	
       }
    }, 100);
  /*Gallery Zoom Thumbnails*/
});